import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, computed, signal } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MobileDrawerMenuItem, MobileDrawerSection } from "../mobile-navigation.models";

@Component({
  selector: "mobile-burger-drawer",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./mobile-burger-drawer.component.html",
  styleUrl: "./mobile-burger-drawer.component.scss",
})
export class MobileBurgerDrawerComponent implements OnChanges {
  @Input() open = false;
  @Input() sections: MobileDrawerSection[] = [];
  @Input() activeAppName: string | null = null;

  @Output() readonly closed = new EventEmitter<void>();
  @Output() readonly backToApps = new EventEmitter<void>();
  @Output() readonly menuSelected = new EventEmitter<string>();
  @Output() readonly itemSelected = new EventEmitter<string>();

  private readonly currentSectionUid = signal<string | null>(null);

  readonly currentSection = computed<MobileDrawerSection | null>(() => {
    const uid = this.currentSectionUid();
    if (!uid) {
      return null;
    }
    return this.sections.find((section) => section.Uid === uid) ?? null;
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["open"] && !this.open) {
      this.currentSectionUid.set(null);
    }
  }

  /** Aligné web {@link MenuAccordionComponent.shouldShowSubmenuPanel} : 1 entrée → route directe. */
  openSection(uid: string): void {
    const section = this.sections.find((entry) => entry.Uid === uid);
    if (!section || section.Items.length === 0) {
      return;
    }
    if (section.Items.length === 1) {
      const route = section.Items[0]?.Route?.trim();
      if (route) {
        this.itemSelected.emit(route);
      }
      return;
    }
    this.currentSectionUid.set(uid);
  }

  sectionShowsSubmenu(section: MobileDrawerSection): boolean {
    return section.Items.length > 1;
  }

  goBackToMenus(): void {
    this.currentSectionUid.set(null);
  }

  sectionLabel(section: MobileDrawerSection): string {
    return section.Label?.trim() || section.LabelKey;
  }

  itemLabel(item: MobileDrawerMenuItem): string {
    return item.Label?.trim() || item.LabelKey;
  }
}
